import { SubTableColumn } from 'src/components/commons/subTable/types';

const COLUMNS: SubTableColumn[] = [
  {
    title: 'NAME',
    dataIndex: 'name',
    editable: true,
    unique: true,
    required: true,
    key: '',
    minWidth: 270,
    dataType: 'string',
    hidden: false,
    dataStructure: 'string',
    headerName: 'NAME',
    options: [],
    orderField: 'name',
    searchField: 'name',
  },
  {
    title: 'DESCRIPTION',
    dataIndex: 'description',
    editable: true,
    key: '',
    minWidth: 270,
    dataType: 'string',
    hidden: false,
    dataStructure: 'string',
    headerName: 'DESCRIPTION',
    options: [],
    orderField: 'description',
    searchField: 'description',
  },
];

export default COLUMNS;
